export const aboutData = {
  current_title: "Software Engineer",
  description:
    "Detail-oriented and solutions-driven IT professional with a strong foundation in cybersecurity, cloud infrastructure, and backend software development, complemented by hands-on experience building and deploying secure, scalable, and AI-enhanced web applications. Proven ability to design full-stack systems using technologies such as Django, Node.js, React, AWS, PostgreSQL, and Redis, with a particular focus on data architecture, service-oriented APIs, and modern authentication flows.",
  skills: [
    "Python",
    "JavaScript",
    "Java",
    "Node.js",
    "React",
    "Next.js",
    "Django",
    "FastAPI",
    "Serverless Architecture",
    "Event-Driven Systems",
    "REST API Design",
    "GraphQL",
    "LLM Integration",
    "Rate Limiting & Throttling",
    "Authentication",
    "Docker & Containerization",
    "Infrastructure as Code",
    "CI/CD Automation",
    "AWS | Azure | Cloudflare",
    "PostgreSQL | MySQL | Redis | Cosmos DB",
    "Microservices Architecture",
  ],
  certifications: [
    {
      name: "TestOut Security Pro",
      company: "CompTIA",
      certificate_id: "6-2C6-VDXJKV",
      link: "https://certification.testout.com/verifycert/6-2C6-VDXJKV",
    },
    {
      name: "TestOut Network Pro",
      company: "CompTIA",
      certificate_id: "6-2C6-V9XETD",
      link: "https://certification.testout.com/verifycert/6-2C6-V9XETD",
    },
    {
      name: "TestOut Client Pro",
      company: "CompTIA",
      certificate_id: "6-2C6-VVQN4G",
      link: "https://certification.testout.com/verifycert/6-2C6-VVQN4G",
    },
    {
      name: "TestOut Hybrid Server Pro",
      company: "CompTIA",
      certificate_id: "6-2C6-V9WLBA",
      link: "https://certification.testout.com/verifycert/6-2C6-V9WLBA",
    },
    {
      name: "TestOut Linux Pro",
      company: "CompTIA",
      certificate_id: "6-2C6-VQ5T22",
      link: "https://certification.platform.comptia.org/verifycert/6-2C6-VQ5T22",
    },
  ],
  education: {
    institution: "Ensign College",
    degree: "Bachelor of Applied Science in Software Engineering",
    duration: "2022 - 2025",
    location: "Salt Lake City, UT",
    link: "https://www.parchment.com/u/award/6b7c7f45aea459fddc3cc4204f653c58",
  },
};
